module.exports = "pegasus/assets/email1-header-3.png";